import { useParams } from "react-router-dom";
import { PropertyContextProvider } from "@/contexts/PropertyContext";
import PropertyDetail from "@/pages/owner/PropertyDetail";

/**
 * Wraps PropertyDetail with PropertyContextProvider so propertyId from route is available in context.
 * Used by route /properties/:propertyId (guard wraps this).
 */
export default function PropertyDetailRoute() {
  const { propertyId } = useParams<{ propertyId: string }>();
  return (
    <PropertyContextProvider propertyId={propertyId}>
      <PropertyDetail />
    </PropertyContextProvider>
  );
}
